import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Sparkles } from 'lucide-react';

const CHECKOUT_URL = 'https://pay.routerfy.com/c/01k9qtctgem89zzktgpvzw6d0f';

export const FIPHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'glass-effect shadow-lg' : 'bg-white/90 backdrop-blur-md'
      }`}
      style={{ height: '80px' }}
    >
      <div className="container-fip h-full flex items-center justify-between">
{/* Logo */}
<div className="flex items-center">
  <div className="flex items-center gap-3 group cursor-pointer">
    <div className="relative">
      {/* Substituindo o fundo colorido e texto por imagem */}
      <div className="w-12 h-12 rounded-xl overflow-hidden shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
        <img
          src="./Logo.png" // 👉 Substitua pelo caminho da sua imagem
          alt="Logo NBZ"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute -top-1 -right-1 w-3 h-3 bg-accent rounded-full animate-pulse"></div>
    </div>
    <div>
      <div className="text-primary font-bold text-lg leading-tight">NBZ</div>
      <div className="text-primary/70 text-sm leading-tight font-medium">Educação</div>
    </div>
  </div>
</div>

        {/* CTA Button */}
        <Button 
          className="bg-gradient-to-r from-accent to-accent-hover hover:from-accent-hover hover:to-accent text-primary font-bold px-8 py-3 rounded-xl transition-all duration-300 hover:shadow-2xl relative overflow-hidden group"
          onClick={() => window.open(CHECKOUT_URL, '_blank')}
        >
          <span className="relative z-10 flex items-center gap-2">
            <Sparkles className="w-4 h-4" />
            Quero me inscrever
          </span>
          <div className="absolute inset-0 bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
        </Button>
      </div>
    </header>
  );
};